import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import {
  connectFirestoreEmulator,
  getFirestore,
} from "firebase/firestore";
import {
  AUTH_EMULATOR_URL,
  EMULATOR_PROJECT_ID,
  FIRESTORE_EMULATOR_HOST,
  FIRESTORE_EMULATOR_PORT,
  getFirebaseRuntime,
} from "./runtimeEnvironment";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const productionFirebaseConfig = {
  apiKey: "AIzaSyBeryzZqKpFkzL02zI1ZXVuCh6Hmpo8qvs",
  authDomain: "lettucetalk-customize.firebaseapp.com",
  projectId: "lettucetalk-customize",
  storageBucket: "lettucetalk-customize.firebasestorage.app",
  messagingSenderId: "755511276120",
  appId: "1:755511276120:web:0eed5b487a7c716b19102d",
  measurementId: "G-L4B73QXMEH"
};

const emulatorFirebaseConfig = {
  apiKey: "demo-api-key",
  authDomain: `${EMULATOR_PROJECT_ID}.firebaseapp.com`,
  projectId: EMULATOR_PROJECT_ID,
  storageBucket: `${EMULATOR_PROJECT_ID}.firebasestorage.app`,
  messagingSenderId: "demo-messaging-sender-id",
  appId: "demo-app-id",
};

const { useEmulators } = getFirebaseRuntime();
const app = initializeApp(
  useEmulators ? emulatorFirebaseConfig : productionFirebaseConfig
);
const auth = getAuth(app);
const db = getFirestore(app);

// These connectors run during module initialization, before consumers can
// issue Auth or Firestore operations. Module scope also keeps React Strict
// Mode from applying them twice.
if (useEmulators) {
  connectAuthEmulator(auth, AUTH_EMULATOR_URL, { disableWarnings: true });
  connectFirestoreEmulator(
    db,
    FIRESTORE_EMULATOR_HOST,
    FIRESTORE_EMULATOR_PORT
  );
}

export { auth, db };
